import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

const AccountDeletionSuccessRoute = lazyRouteComponent(
  () => import('@/features/account/AccountDeletionSuccess'),
  'AccountDeletionSuccess'
)

export const Route = createFileRoute('/sucesso-exclusao')({
  component: AccountDeletionSuccessRoute,
})
